import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './sidebar';

const BlogSliderCustom = ({customClass, sectionClass}) => {

	const [blog, setBlog] = useState([
		{
			id: 1,
			title: "10 Brilliant Ways To Decorate Your Home",
			description: "10 Brilliant Ways To Decorate Your Home",
			feature_image: "mechanical-work.jpg",
			author: "Admin",
			tag: "Production",
			date: "June 24, 2021"
		},
		{
			id: 2,
			title: "10 Brilliant Ways To Decorate Your Home",
			description: "10 Brilliant Ways To Decorate Your Home",
			feature_image: "mechanical-work.jpg",
			author: "Admin",
			tag: "Production",
			date: "June 24, 2021"
		},
		{
			id: 3,
			title: "10 Brilliant Ways To Decorate Your Home",
			description: "10 Brilliant Ways To Decorate Your Home",
			feature_image: "mechanical-work.jpg",
			author: "Admin",
			tag: "Production",
			date: "June 24, 2021"
		},
		{
			id: 4,
			title: "10 Brilliant Ways To Decorate Your Home",
			description: "10 Brilliant Ways To Decorate Your Home",
			feature_image: "mechanical-work.jpg",
			author: "Admin",
			tag: "Production",
			date: "June 24, 2021"
		},
		{
			id: 5,
			title: "10 Brilliant Ways To Decorate Your Home",
			description: "10 Brilliant Ways To Decorate Your Home",
			feature_image: "mechanical-work.jpg",
			author: "Admin",
			tag: "Production",
			date: "June 24, 2021"
		},
		{
			id: 6,
			title: "10 Brilliant Ways To Decorate Your Home",
			description: "10 Brilliant Ways To Decorate Your Home",
			feature_image: "mechanical-work.jpg",
			author: "Admin",
			tag: "Production",
			date: "June 24, 2021"
		}
	]);

	let publicUrl = process.env.PUBLIC_URL + '/';
	// let customClass2 = customClass ? customClass : '';
	// let sectionClass2 = sectionClass ? sectionClass : '';
	return (
		<div className={"blog-custom-section section-bg-1 pt-40 pb-40 go-top " + sectionClass}>
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title-area ltn__section-title-2--- text-center">
							<h6 className={"section-subtitle secondary-color " + customClass}>News &amp; Blogs</h6>
							<h1 className="section-title">Latest <span>News Feeds</span></h1>
						</div>
					</div>
				</div>
				<div className="row  ltn__blog-slider-custom slick-arrow-1 ltn__blog-item-3-normal">
					{/* Blog Item */}
					{blog.map((item, index) => {
						return (
							<div className="col-lg-12" key={index}>
								<div className="ltn__blog-item ltn__blog-item-3">
									<div className="ltn__blog-img">
										<Link to="/"><img src={publicUrl + "assets/img/llabdhi_img/"+item?.feature_image} alt="#" /></Link>
									</div>
									<div className="ltn__blog-brief">
										<div className="ltn__blog-meta">
											<ul>
												<li className="ltn__blog-author">
													<Link to="/"><i className="far fa-user" />by: {item?.author}</Link>
												</li>
												<li className="ltn__blog-tags">
													<Link to="/"><i className="fas fa-tags" />{item?.tag}</Link>
												</li>
											</ul>
										</div>
										<h3 className="ltn__blog-title"><Link to="/">{item?.description}</Link></h3>
										<div className="ltn__blog-meta-btn">
											<div className="ltn__blog-meta">
												<ul>
													<li className="ltn__blog-date"><i className="far fa-calendar-alt" />{item?.date}</li>
												</ul>
											</div>
											<div className="ltn__blog-btn">
												<Link to="/">Read more</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						)
					})}
					{/*  */}
				</div>
			</div>
		</div>
	)
}

export default BlogSliderCustom;
